<!-- contactus.component.html -->

<section class="contact-section">

    <div class="contact-container">

        <!-- LEFT SIDE -->

        <div class="contact-info">

            <span class="small-title">
                CONTACT US
            </span>

            <h1>
                Get In Touch With Suncrest Global
            </h1>

            <p>
                Have questions or need assistance?
                Contact us for support, inquiries, export partnerships,
                or product information.
                We are committed to delivering premium quality spices,
                tea, and organic products worldwide.
            </p>

            <div class="info-box">

                <div class="info-item">
                    <div class="icon">📍</div>

                    <div>
                        <h4>Address</h4>
                        <p>Kolkata, West Bengal, India</p>
                    </div>
                </div>

                <div class="info-item">
                    <div class="icon">📞</div>

                    <div>
                        <h4>Phone</h4>
                        <p>+91 8617702758</p>
                    </div>
                </div>

                <div class="info-item">
                    <div class="icon">✉️</div>

                    <div>
                        <h4>Email</h4>
                        <p>info@suncrestglobalventures.com</p>
                    </div>
                </div>

                <div class="info-item">
                    <div class="icon">⏰</div>

                    <div>
                        <h4>Opening Hours</h4>
                        <p>Monday - Saturday : 9:00 AM - 6:00 PM</p>
                        <p>Sunday : Closed</p>
                    </div>
                </div>

            </div>

        </div>

        <!-- RIGHT SIDE -->

        <div class="contact-form-box">

            <h2>Send Your Inquiry</h2>

            <form [formGroup]="loginForm" (ngSubmit)="onSubmit()">

                <!-- NAME -->

                <div class="form-group">

                    <input
                        type="text"
                        formControlName="name"
                        placeholder="Your Name">

                    <div class="error"
                        *ngIf="loginForm.get('name')?.touched &&
                               loginForm.get('name')?.invalid">

                        <small *ngIf="loginForm.get('name')?.errors?.required">
                            Name is required
                        </small>

                        <small *ngIf="loginForm.get('name')?.errors?.minlength">
                            Minimum 3 characters
                        </small>

                    </div>

                </div>

                <!-- EMAIL -->

                <div class="form-group">

                    <input
                        type="email"
                        formControlName="email"
                        placeholder="Your Email">

                    <div class="error"
                        *ngIf="loginForm.get('email')?.touched &&
                               loginForm.get('email')?.invalid">

                        <small *ngIf="loginForm.get('email')?.errors?.required">
                            Email is required
                        </small>

                        <small *ngIf="loginForm.get('email')?.errors?.email">
                            Invalid email address
                        </small>

                    </div>

                </div>

                <!-- MOBILE -->

                <div class="form-group">

                    <input
                        type="number"
                        formControlName="mobile"
                        placeholder="Mobile Number">

                    <div class="error"
                        *ngIf="loginForm.get('mobile')?.touched &&
                               loginForm.get('mobile')?.invalid">

                        <small *ngIf="loginForm.get('mobile')?.errors?.required">
                            Mobile number is required
                        </small>

                    </div>

                </div>

                <!-- MESSAGE -->

                <div class="form-group">

                    <textarea
                        rows="5"
                        formControlName="message"
                        placeholder="Write your message">
                    </textarea>

                    <div class="error"
                        *ngIf="loginForm.get('message')?.touched &&
                               loginForm.get('message')?.invalid">

                        <small *ngIf="loginForm.get('message')?.errors?.required">
                            Message is required
                        </small>

                        <small *ngIf="loginForm.get('message')?.errors?.minlength">
                            Minimum 5 characters
                        </small>

                    </div>

                </div>

                <!-- BUTTON -->

                <button type="submit" class="submit-btn">
                    Send Message
                </button>

            </form>

        </div>

    </div>

</section>